<template>
    <div class="discountServiceItem" @click="onClickItem(item)">
        <div class="imgBox">
            <QualityImg
                :src="item.img_url"
                width="330"
                height="200"
            />
            <span class="vip" v-if="Boolean(item.is_vip)">渠道专享</span>
            <p class="info" v-if="isShowStoreInfo">{{ item.distance | distance2 }} · {{ item.store_name }}</p>
        </div>
        <div class="infoBox">
            <h5>{{ item.activity_title }}</h5>
            <p class="tags">
                <span :key="tagsItem" v-for="(tagsItem, tagsIndex) in item.activity_tags">
                    <i>{{ tagsItem }}</i>
                    <i v-if="tagsIndex + 1 !== item.activity_tags.length">&nbsp;|&nbsp;</i>
                </span>
            </p>
            <p class="price">
                <span class="flag">￥</span>{{ item.price }}
            </p>
        </div>
    </div>
</template>

<script>
import QualityImg from '@/components/qualityImg/qualityImg.vue'
export default {
    name: 'discountServiceItem',
    data () {
        return {
        }
    },
    components:{
        QualityImg
    },
    props: {
        item: {
            type: Object,
            default () {
                return {}
            }
        },
        isShowStoreInfo: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onClickItem (item) {
            this.$emit('onClickItem', item)
        }
    }
}
</script>

<style lang="stylus" scoped>
// @import "~@/assets/stylus/variables.styl";
// @import "~@/assets/stylus/mixin.styl";

.discountServiceItem
    padding 30px 20px
    border-radius 14px
    display flex
    background #fff
    .imgBox
        // box-sizing border-box
        width 330px
        height 200px
        border-radius 16px
        overflow hidden
        position relative
        img
            width 100%
            height 100%
        .vip
            width 130px
            height 38px
            line-height 38px
            color #fff
            font-size 24px
            text-align center
            background-color #7e00ff
            border-bottom-right-radius 16px
            position absolute
            top 0
            left 0
            z-index 1
        .info
            box-sizing border-box
            background #efefef
            height 50px
            line-height 50px
            text-align left
            padding 0 22px
            font-size 24px
            color #666666
            width 100%
            position absolute
            bottom 0
            left 0
            z-index 99
            textOverflow()
    .infoBox
        flex 1
        margin-left 26px
        h5
            font-size 28px
            line-height 36px
            color #333333
            font-weight normal
            margin 0
            mutiLineTextOverFlow(2)
        .tags
            font-size 24px
            line-height 32px
            color #999999
            margin 22px 0
            i
                font-style inherit
        .price
            font-size 30px
            line-height 38px
            vertical-align bottom
            color #fc2d2d
            .flag
                font-size 22px
                line-height 30px
                vertical-align bottom
</style>
